"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
var switchHeight = {
    xs: 14,
    sm: 18,
    md: 22,
    lg: 28,
    xl: 34,
};
var switchWidth = {
    xs: 28,
    sm: 36,
    md: 42,
    lg: 54,
    xl: 66,
};
var handleSizes = {
    xs: 10,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 26,
};
exports.sizes = Object.keys(switchHeight).reduce(function (acc, size) {
    acc[size] = { width: switchWidth[size], height: switchHeight[size] };
    return acc;
}, {});
exports.default = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    switch: function (_a) {
        var size = _a.size, radius = _a.radius, theme = _a.theme, reduceMotion = _a.reduceMotion, color = _a.color;
        var handleSize = theme_1.getSizeValue({ size: size, sizes: handleSizes });
        var borderRadius = theme_1.getSizeValue({ size: radius, sizes: theme.radius });
        return __assign(__assign({}, theme_1.getFocusStyles(theme)), { WebkitTapHighlightColor: 'transparent', position: 'relative', borderRadius: borderRadius, backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[2], border: "1px solid " + (theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[3]), height: theme_1.getSizeValue({ size: size, sizes: switchHeight }), width: theme_1.getSizeValue({ size: size, sizes: switchWidth }), minWidth: theme_1.getSizeValue({ size: size, sizes: switchWidth }), padding: [0, 2], margin: 0, transitionProperty: 'background-color, border-color', transitionTimingFunction: theme.transitionTimingFunction, transitionDuration: reduceMotion ? '1ms' : '150ms', boxSizing: 'border-box', appearance: 'none', display: 'flex', alignItems: 'center', '&::before': {
                borderRadius: borderRadius,
                boxSizing: 'border-box',
                content: "''",
                display: 'block',
                backgroundColor: theme.white,
                height: handleSize,
                width: handleSize,
                border: "1px solid " + (theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[3]),
                transition: reduceMotion ? 'none' : "transform 150ms " + theme.transitionTimingFunction,
            }, '&:checked': {
                backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: 6 }),
                borderColor: theme_1.getThemeColor({ theme: theme, color: color, shade: 6 }),
                '&::before': {
                    transform: "translateX(" + (theme_1.getSizeValue({ size: size, sizes: switchWidth }) -
                        theme_1.getSizeValue({ size: size, sizes: handleSizes }) -
                        6 // borderWidth: 2 + padding: 2 * 2
                    ) + "px)",
                    borderColor: theme_1.getThemeColor({ theme: theme, color: color, shade: 6 }),
                },
            }, '&:disabled': {
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],
                borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],
                cursor: 'not-allowed',
                '&::before': {
                    borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],
                    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[0],
                },
            } });
    },
    label: function (_a) {
        var theme = _a.theme, size = _a.size;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { WebkitTapHighlightColor: 'transparent', fontSize: theme_1.getSizeValue({ size: size, sizes: theme.fontSizes }), fontFamily: theme.fontFamily, paddingLeft: theme.spacing.sm, color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black }));
    },
}, { link: true });
